import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/system';

interface IGenericDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  iconTitle?: React.ReactNode;
  children: React.ReactNode;
  anchor?: 'left' | 'right' | 'top' | 'bottom';
  disableEscapeKeyDown?: boolean;
  sx?: SxProps<Theme>;
}

const GenericDrawer = ({
  open,
  onClose,
  title,
  iconTitle,
  children,
  anchor = 'right',
  disableEscapeKeyDown = false,
  sx,
}: IGenericDrawerProps) => {
  const theme = useTheme();
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={disableEscapeKeyDown}
      sx={{
        ...sx,
        position: 'relative',
        zIndex: 1202,
        '& .MuiDrawer-paper': {
          width: '45%',
          padding: '0',
          borderRadius: '0.5rem 0 0 0.5rem',
          [theme.breakpoints.down('lg')]: {
            width: '100%',
            borderRadius: '0',
          },
        },
        [theme.breakpoints.down('lg')]: {
          width: '100%',
        },
      }}
    >
      <Box>
        <Box
          display="flex"
          gap="1rem"
          alignItems="center"
          justifyContent="space-between"
          padding={theme.spacing(2, 4)}
        >
          <Box display="flex" gap="1rem" alignItems="center">
            {iconTitle ? iconTitle : null}
            <Typography variant="h5" fontWeight={theme.typography.fontWeightMedium}>
              {title}
            </Typography>
          </Box>
          <IconButton onClick={onClose} edge="end">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider variant="fullWidth" />
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            padding: '0 5vh 3.5rem',
            [theme.breakpoints.down('sm')]: { padding: '0 2vh 3.5rem' },
          }}
        >
          {children}
        </Box>
      </Box>
    </Drawer>
  );
};

export default GenericDrawer;
